export class Estado {
  sigla: string;
  descricao: string;

  constructor(sigla: string, descricao: string) {
    this.sigla = sigla;
    this.descricao = descricao;
  }
}
